import { Component } from '@angular/core';
import { HelperService } from './common/helper.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ges';
  loading = true;
  constructor(private helperService: HelperService) {
  }

  onInit() {
  }
  
}
